import { Usage } from '@/Domain/api/Subscription/dto/SubscriptionUsage.dto';

// Matches the backend's DEFAULT_CREDIT_COST; only reached if the rate is missing or unusable.
const DEFAULT_CREDIT_COST_PER_MESSAGE = 1;

export const creditCostPerMessage = (usage: Usage | undefined): number => {
  // A pre-deploy pod serves no rate, and the cache would keep that payload all session.
  const servedRate = usage?.credit_cost_per_message;
  return typeof servedRate === 'number' && Number.isFinite(servedRate) && servedRate > 0
    ? servedRate
    : DEFAULT_CREDIT_COST_PER_MESSAGE;
};

export const planCreditsRemaining = (usage: Usage | undefined): number =>
  usage ? Math.max(0, usage.messages_limit - usage.messages_used) : 0;

// Per pool, mirroring `verify_messages_allowance`: the two remainders never fund a reply together.
export const affordableMessages = (usage: Usage | undefined): number | null => {
  if (!usage) return null;
  const creditRate = creditCostPerMessage(usage);
  return (
    Math.floor(planCreditsRemaining(usage) / creditRate) +
    Math.floor((usage.topup_credits ?? 0) / creditRate)
  );
};

// A non-positive limit is unlimited or unprovisioned, never proof of an outage, so it stays quiet.
export const isAgentOutOfCredits = (usage: Usage | undefined): boolean =>
  !!usage && usage.messages_limit > 0 && affordableMessages(usage) === 0;
